import { Component, ViewChild } from '@angular/core';
import { InvApiService } from '../../API/invapi.service';
import { TableHeadsService } from '../../Core/tableheads.service';
import { IMyDateModel, IAngularMyDpOptions } from 'angular-mydatepicker';
import { Router, NavigationEnd, ActivatedRoute, RoutesRecognized } from '@angular/router';
import { PageHeaderComponent } from '../../Core/pageheader.component';
import { AppComponent } from '../../app.component';
import { Globals } from '../../globals';
import { filter, pairwise } from 'rxjs/operators';
import { PreviousRouteService } from 'src/app/Core/services/previous-route.service';
import { AuthService } from 'src/app/API/auth.service';
import { Observable } from 'rxjs';
import { CommonApiService } from 'src/app/API/commonapi.service.';
import { PartsComponent } from 'src/app/Core/Shared/PartsControl/PartsComponent';
import { PartsInventoryComponent } from 'src/app/Core/Shared/PartsInventoryComponent/PartsInventoryComponent';
@Component({
  selector: 'InventoryCheckIn',
  templateUrl: './InventoryCheckIn.component.html'
})
export class InventoryCheckInComponent {
  UserList: any;
  DivisionList = [];
  VendorList = [];
  page;
  CategoryList = [];
    ManufacturerList = [];
      ModelList = [];
  inventoryControlFlag = false;

  constructor(
    private invapi: InvApiService,
    private router: Router,
    private route: ActivatedRoute,
    private dataGridService: TableHeadsService,
    private previousRouteService: PreviousRouteService,
    private auth: AuthService,
    private commonapi: CommonApiService,
  ) {
  }


  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean  {
    this.invapi.setSearchValue(this.page);
    return true;
  }

  @ViewChild(PageHeaderComponent, { static: true })
  pageheader: PageHeaderComponent;

  @ViewChild(PartsInventoryComponent, { static: false })
  parts: PartsInventoryComponent;
    // tslint:disable-next-line:member-ordering
  public myOptions: IAngularMyDpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
    closeSelectorOnDateSelect: false
  };

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnInit() {
    const isInventoryControls = JSON.parse(sessionStorage.getItem('IsInventoryControls') || 'false');
    this.inventoryControlFlag = isInventoryControls;
    if (this.parts) {
      this.parts.currentUserId = this.auth.GetUserId();
    } else {
      console.warn('parts is undefined');
    }  
  }
}
